// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGMPRIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer",
  display: "block",
};

export default class SVGMPRIcon extends PureComponent<ISVGMPRIconProps, {}> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          id="그룹_12"
          data-name="그룹 12"
          transform="translate(-2245.637 143.64)"
        >
          <path
            id="패스_27"
            data-name="패스 27"
            d="M2129.827-156.9v16.714l14.552-8.357V-165.26Z"
            transform="translate(115.81 21.62)"
            //fill="#fff"
          />
          <path
            id="패스_28"
            data-name="패스 28"
            d="M2144.38-156.9v16.714l-14.552-8.357V-165.26Z"
            transform="translate(134.42 21.62)"
            // fill="#fff"
          />
          <path
            id="패스_29"
            data-name="패스 29"
            d="M2129.827-156.9l14.552,8.246,14.8-8.246-14.8-8.357Z"
            transform="translate(118.044 41.657)"
            // fill="#fff"
          />
        </g>
      </svg>
    );
  }
}
